export const HEADER = "HEADER";
export const Scroll_Header = "Scroll_Header";
export const STREAM = "STREAM";
export const Show_Header = "Show_Header";
export const SHOW_FIXED_NAV = "SHOW_FIXED_NAV";
export const HEADER_BG_PROPERTIES = "HEADER_BG_PROPERTIES";
